import {Inject, Pipe, PipeTransform} from '@angular/core';
import {Environment, ENVIRONMENT} from "@nx-averycom/environment";

@Pipe({
  name: 'cloudinaryImg',
})
export class CloudinaryImgPipe implements PipeTransform {
  constructor(@Inject(ENVIRONMENT) private environment: Environment) {
  }
  transform(path: string, params?: string): string {
    return `${this.environment.image}${params || ''}${path}`;
  }
}
